import React, { Component } from 'react';
import styled from 'styled-components'
import Header from './../../Resources/AppScreens/CommonComponents/Healthcare/Header.svg';
import Schedule from './../../Resources/AppScreens/CommonComponents/Healthcare/Schedule Appt.svg';

import Custom2 from './../../Resources/AppScreens/CommonComponents/Healthcare/Manage Your Health.svg';
import Custom1 from './../../Resources/AppScreens/CommonComponents/Healthcare/Button Set 1.svg';
import Custom3 from './../../Resources/AppScreens/CommonComponents/Healthcare/Button Set 2.svg';
import Footer from './../../Resources/AppScreens/CommonComponents/Healthcare/Bottom Navigation.svg';
import HealthcareComponents from './../../Resources/AppScreens/Preview-Features/Healthcare';

import {Container, ScrollableContent as _ScrollableContent} from './Common';

const ScrollableContent = styled(_ScrollableContent)`
    margin-top: 13px;
    gap: 5px;
    &>* {
        flex-shrink: 0;
    }
`;

const HealthcarePreview = ({ features }) => (<Container>
    <img src={Header} style={{width: "100%"} } />
    <ScrollableContent>
        <img src={Schedule} />
        <img src={Custom1} />
        <img src={Custom3} />
        <img src={Custom2} style={{marginTop: "10px"}} />
        {features && features.map(feature => HealthcareComponents[feature])}
    </ScrollableContent>
    <img src={Footer} style={{ marginBottom: "0px;", marginTop: "auto", width: "100%", width: "100%" }} />
</Container>);

export default HealthcarePreview;

